export const translationAr = {
  common: {
    previous: "رجوع",
    next: "التالي",
    SAR: "ريال",
    yes: "نعم",
    no: "لا",
  },
  "404-page": {
    title: "404",
    subTitle: "الصفحة التي زرتها غير موجودة",
    backHome: "العودة إلى الصفحة الرئيسية",
  },
  welcome: {
    welcomeHeading: "احصل على أفضل أسعار التمويل العقاري لمنزل أحلامك",
    loanFactorsTitle:
      "يعتمد الحد الأعلى لتمويلك العقاري وقيمة الأقساط الشهرية والمعدل على",
    loanFactorWorkSector: "قطاع العمل",
    loanFactorSalary: "الراتب",
    loanFactorGovernmentSupport: "أهلية الدعم الحكومي",
    welcomeDescription: "ابدأ الآن لتتعرف على فرص التمويل المتاحة لك",
    termsAgreementPrefix: "أنا أوافق على ال",
    termsAgreementLink: "الشروط والأحكام.",
    simahAgreement: "أنا أوافق على جلب بياناتي من SIMAH",
    startButton: "ابدأ الآن",
  },
  homePurchaseQuestionnaire: {
    requiredFields: "الرجاء الإجابة عن جميع الأسئلة المطلوبة",
    headerText: "سنعمل على إيجاد التمويل العقاري المناسب لك ولإحتياجاتك",
    question1: "هل وجدت العقار المناسب؟",
    question1Options: {
      yes: "نعم",
      no: "لا",
    },
    question2: " في أي مرحلة من مراحل الشراء تتواجد الآن؟",
    question2OptionsYes: {
      iWouldLikeToMakeSureICanPurchase: "ارغب بالتأكد من امكانية الشراء",
      iReservedTheUnit: "قمت بحجز الوحده",
    },
    question2OptionsNo: {
      iamNotThinkingAboutBuyingRightNow: "لا افكر في بالشراء حالياً",
      iamStillExploringOpportunitiesInTheMarket:
        "ما زلت استكشف الفرص المتاحه في السوق",
    },
    question3: "متى تريد الشراء؟",
    question3Options: {
      zeroToThreeMonths: "3-0 أشهر",
      fourToSixMonths: "6-4 أشهر",
      sixMonthPlus: "6+ أشهر",
      notSure: "غير متأكد",
    },
  },
  workQuestionnaire: {
    // Page title
    title: "من فضلك أخبرنا عن عملك الحالي",

    // Job type selection
    jobTypeRequired: "يرجى اختيار نوع الوظيفة.",
    jobTypes: {
      government: "حكومي مدني",
      military: "حكومي عسكري",
      privateSME: "قطاع خاص (مؤسسة)",
      privateEnterprise: "قطاع خاص (شركات صغيرة ومتوسطة)",
      retired: "متقاعد",
    },
    typeOfMortgageOptions: {
      readyUnit: "وحدة جاهزة",
      saleOnTheMap: "بيع على الخريطة",
      selfBuild: "بناء ذاتي",
      other: "اخرى",
    },
    // Military specific fields
    militaryRank: "الرتبة",
    militaryRankRequired: "يرجى اختيار الرتبة العسكرية.",
    isPilot: "هل أنت طيار؟",
    pilotRequired: "يرجى تحديد ما إذا كنت طيارًا.",

    // Common form fields
    employerName: {
      label: "اكتب اسمك",
      placeholder: "عبدالرحمن صالح",
      required: "يرجى إدخال اسمك",
    },

    salary: {
      basic: {
        label: "الراتب الأساسي",
        placeholder: "اكتب الراتب الأساسي هنا",
        required: "يرجى إدخال الراتب الأساسي.",
      },
      net: {
        label: "صافي الراتب بعد خصم التأمينات",
        placeholder:
          "المبلغ الذي يحول الى حسابك البنكي بشكل شهري بعد خصم التأمينات",
        required: "يرجى إدخال راتبك الشهري.",
        info: "راتبك الشهري المودع في الحساب البنكي بعد خصم التأمينات",
        error: "الراتب الصافي لا يمكن أن يكون أقل من الراتب الأساسي.",
      },
    },

    bank: {
      label: "اسم البنك الذي يحول إليه راتبك الشهري",
      placeholder: "فضلاً اختر اسم البنك",
      required: "يرجى اختيار البنك الخاص براتبك.",
    },

    mortgage: {
      type: {
        label: "نوع التمويل العقاري",
        placeholder: "اختر نوع التمويل",
        required: "يرجى اختيار نوع التمويل العقاري",
        options: {
          readyUnit: "وحدة جاهزة",
          saleOnTheMap: "بيع على الخريطة",
          selfBuild: "بناء ذاتي",
          other: "اخرى",
        },
      },
      amount: {
        label: "مبلغ التمويل",
        placeholder: "أدخل مبلغ التمويل",
        required: "يرجى إدخال مبلغ التمويل",
      },
    },

    // Form validation
    pleaseAnswerAllQuestions: "الرجاء الإجابة عن جميع الأسئلة المطلوبة",
  },
  loanQuestionnaire: {
    title: "أخبرنا عن التزاماتك المالية",
    question1: "هل لديك أي قروض؟",
    questionRequired: "يرجى الإجابة عن هذه السؤال",
    question1Options: {
      yes: "نعم",
      no: "لا",
    },
    question1OptionsYes: {
      description:
        "ما هو إجمالي التزاماتك المالية الشهرية (إجمالي قسط الإلتزام الشهري) بالريال السعودي وعدد السنوات المتبقية للالتزامات؟",
      total: "الإجمالي",
      remaining: "عدد السنوات المتبقية للالتزامات",
      sixMonths: "6 شهور",
      fiveYears: "5 سنوات",
      loanType: "اختر نوع الإلتزام",
      loanTypeOptions: {
        mortgage: "تمويل عقاري",
        personal: "تمويل شخصي",
        car: "تمويل السيارة",
        // possibilty: "إمكان",
        creditCard: "بطاقة الائتمان",
        DBS: "بنك التنمية الاجتماعية",
        jisr: "جسر",
      },
    },
    question2: "هل لديك متعثرات في السداد حالياً لدى سمة؟",
    question2Options: {
      yes: "نعم",
      no: "لا",
    },
  },
  governmentSubsidyAndEligibilitySupport: {
    fieldRequired: "الرجاء الإجابة عن جميع الأسئلة المطلوبة",
    firstHomeTitle: "مسكنك الأول، بدون ضريبة",
    royalDecree: "الأمر الملكي رقم (أ/86) وتاريخ 18/04/1439هـ ينص على أنه",
    royalDecreeInfo:
      "تتحمل الدولة ضريبة القيمة المضافة على مبلغ لا يتجاوز (مليون ريال) من سعر شراء المسكن الأول للمواطن، وذلك لتخفيض تكلفة تملك المسكن المناسب للمواطنين",
    isFirstHome: "هل هذا مسكنك الأول؟",
    yesFirstHome: "نعم، هذا هو مسكني الأول",
    noHadHomeBefore: "لا، لدي مسكن من قبل",
    housingSupport: "أحقية برنامج الدعم السكني",
    supportProgramInfo:
      "برنامج الدعم السكني المحدث هو أحد الحلول المقدمة لتسهيل امتلاك المسكن للمستفيد وذلك من خلال تقديم دعم مالي غير مسترد بمبلغ ثابت 100 او 150 ألف ريال حسب مصفوفة المنتجات المعتمدة.",
    areYouEligible: "هل أنت مستحق لبرنامج الدعم 'سكني'؟",
    yesEligible: "نعم، مستحق",
    notEligible: "لا، غير مستحق",
    notSure: "غير متأكد",
    isPropertyReady: "هل العقار جاهز؟",
    yes: "نعم",
    no: "لا",
    back: "رجوع",
    calculate: "احسب",
  },
  realEstateFinanceExpert: {
    welcome: "سنعمل على إيجاد التمويل العقاري المناسب لك ولإحتياجاتك",
    yourLimit: "حد التمويل العقاري الخاص بك هو",
    currency: "ريال",
    benefitsTitle:
      "استفد من مزايا خدمة التواصل مع خبير التمويل العقاري واحصل على أفضل عرض تمويلي من من 16 جهة تمويل لتوفير:",
    benefit1: "مبلغ تمويل مناسب حسب احتياجاتك",
    benefit2: "قسط شهري مناسب حسب ميزانيتك",
    benefit3: "هامش ربح مناسب خاص بتمويلك",
    additionalBenefits:
      "وهناك مزايا إضافية من متابعة التحديثات للتمويل الخاص بك من قبل خبير التمويل العقاري أول بأول وكذلك متابعة كافة الإجراءات بالنيابة عنك.",
    additionalBenefit1:
      "متابعة التحديثات للتمويل الخاص بك من قبل خبير التمويل العقاري أول بأول",
    additionalBenefit2:
      "متابعة إجراءات التمويل العقاري بالنيابة عنك وصولا إلى الإفراغ العقاري",
    additionalBenefit3:
      "تولي إجراءات التمويل كاملة وتقديم أفضل الخيارات المناسبة لك",
    startService: "ابدأ الخدمة الآن",
    disclaimer: "لا شكراً، غير مهتم الآن",
  },
  paymentMethods: {
    welcome: "أهلا بك في خدمة خبير التمويل العقاري",
    serviceInfo: "يسعدنا خدمتك رغبتك في تجربة الخدمة",
    serviceFee: "رسوم الخدمة",
    includeText: "الضريبة المضافة",
    currency: "ريال",
    payNow: "ادفع الآن لبدء الخدمة وتقديم الطلب",
    selectPayment: "اختر طريقة الدفع التي تفضلها",
    applePay: "آبل باي",
    card: "بطاقة الدفع",
    payNowButton: "ادفع الآن",
    cancel: "إلغاء",
    error: "خطأ",
    processing: "يتم المعالجة...",
    paymentProcessingFailed: "فشل معالجة الدفع. يرجى المحاولة مرة أخرى.",
    paymentSDKFailedToLoad: "فشل تحميل SDK الدفع. يرجى تحديث الصفحة.",
    paymentProcessedSuccessfully: "تم معالجة الدفع بنجاح!",
    applePayError: "خطأ في آبل باي",
    paymentCancelled: "تم إلغاء الدفع",
    paymentInitializationFailed: "فشل تهيئة الدفع. يرجى المحاولة مرة أخرى.",
    cardValidationFailed:
      "فشل التحقق من البطاقة. يرجى التحقق من البيانات المدخلة.",
  },
  feedback: {
    welcome: "أهلا بك في خدمة خبير التمويل العقاري",
    title: "شكراً، تم إكمال الدفع بنجاح",
    message:
      "سيتم الاتصال بك لتقديم الخدمة خلال ساعات العمل من الأحد إلى الخميس (إلا للأعمال الرسمية) من التسعة الصباح إلى الخامس المساء، أقصى ساعتين 48 ساعة بعد استلام الطلب.",
    label: "هل لديك رسالة أو سؤال لإرساله مع طلبك؟",
    optional: "اختياري",
    placeholder: "اكتب رسالتك هنا...",
    fieldRequired: "يرجى إدخال رسالتك",
    submit: "شكراً، إرسال الطلب",
    cancel: "إلغاء",
    successMessage: "شكراً لرسالتك!",
  },
  phoneSeller: {
    title: "زرت العقار وصامل تشتري؟",
    hint_part_1: "في حال وجدت العقار ضع رقم البائع",
    hint_part_2: "واحصل على:",
    enterSellerNumber: "إذا وجدت العقار، أدخل رقم البائع",
    andGet: "واحصل على:",
    benefits: {
      competitiveOffers: "١- عروض تمويل تنافسية من جميع البنوك",
      freeService: "٢- ⁠⁠خدمة مجانية لإنهاء الإجراءات دون تكلفة إضافية",
      savingsUpTo: "٣- توفير يصل الى",
      savingsAmount: "٤,٠٠٠ ريال",
      adminFees: "في الرسوم الإدارية",
    },
    buyerMobile: {
      label: "رقم جوال",
      subLabel: "الخاص بك",
      placeholder: "٥xxxxxxxx",
    },
    sellerMobile: {
      label: "رقم جوال",
      subLabel: "المسوق العقاري أو المالك",
      placeholder: "٥xxxxxxxx",
    },
    validation: {
      sellerNumberFormat: "يجب أن يتكون رقم البائع من ٩ أرقام ويبدأ بـ ٥",
      buyerNumberFormat: "يجب أن يتكون رقم المشتري من ٩ أرقام ويبدأ بـ ٥",
      sameNumbers: "لا يمكن أن يكون رقم البائع والمشتري متطابقين",
      ownMobileNotAllowed: "لا يمكن استخدام رقم جوالك الخاص",
      required: "هذا الحقل مطلوب",
      buyerMobileNotAllowed: "يرجى إدخال رقم جوال صالح",
      sellerMobileNotAllowed: "يرجى إدخال رقم جوال صالح",
      sameMobile: "لا يمكن أن يكون رقم البائع والمشتري متطابقين",
    },
    agreements: {
      visitedProperty: "لقد قمت بزيارة العقار وفحصه",
      contactedSeller: "لقد تواصلت مع البائع / الوسيط العقاري",
    },
    noProperty: {
      title: "باقي ما لقيت عقار؟",
      goTo: "اذهب على",
      calculator: "حاسبة التمويل",
      andKnow: "و اعرف حد تمويلك",
    },
    buttons: {
      submitRequest: "إرسال الطلب",
      calculator: "حاسبة التمويل",
    },
  },
  thankYou: {
    title: "تم إرسال طلبك بنجاح!",
    message:
      "سنتواصل معكم في أقرب وقت لتوفير أفضل العروض التمويلية, نرجو تجهيز:",
    salaryCertificate: "١- تعريف راتب",
    nationalId: "٢-  والهوية الوطنية",
    propertyDeed: "٣- وصك العقار",
  },
  full_name: "الاسم",
  mobile: "رقم الجوال",
  wanted_property: "العقار المرغوب",
  real_state_agreement:
    "أوافق على مشاركة معلوماتي مع المعلن العقاري لإعلامه باهتمامي",
  real_state_share_info: "ارسل بياناتي للمعلن العقاري",
  work_sector: "في أي قطاع تعمل؟",
  price: "السعر",
  real_state_details_header: "حد التمويل الخاص بك",
  real_state_finance_1: "حد التمويل العقاري الخاص بك هو",
  real_state_finance_2: "الخاص بك هو",
  share_personal_info:
    "بادر بمشاركة معلوماتك الأساسية مع المعلن العقاري لتسهيل التواصل وتسريع الإجراءات",
  donot_send_info: "لا أريد الإرسال، شكرًا",
  reject_header: "شكرًا لاستخدامك خدمتنا",
  reject_hint:
    "شكرًا لاستخدامك حاسبة التمويل! خطوتك الأولى نحو التملك تبدأ هنا",
  finance_header: "خدمة خبير التمويل العقاري",
  finance_benifit_from: "استفد من مزايا خدمة التواصل مع",
  real_state_expert: "خبير التمويل العقاري",
  start_service_now: "ابدأ الخدمة الآن",
  edit_calculations:
    "أو للحصول على نتائج محدثة، يمكنك العودة إلى حاسبة التمويل وإجراء حسبة جديدة",
  re_calculate: "العودة الى حاسبة التمويل",
  start_service_header_1: "أهلا بك في خدمة خبير التمويل العقاري",
  start_service_header:
    "✨ استفد من خدمة شاملة تبدأ بـ 💰 تصميم برنامج تمويلي مخصص لك،  بالتعاون مع 🤝 أكثر من 16 جهة تمويل لتوفير:",
  start_service_para_1: "💵 مبلغ تمويلي مناسب حسب احتياجاتك",
  start_service_para_2: "📆 قسط شهري مناسب حسب ميزانيتك",
  start_service_para_3: "🏦 هامش ربح مناسب خاص بتمويلك",
  start_service_para_5: "🧭 ونكمل معك المشوار حتى التملك من خلال:",
  start_service_para_6: "🏘️ البحث عن عقارات تناسبك",
  start_service_para_7: "🤝 دعمك في التفاوض مع البائع",
  start_service_para_8: "🧾 مرافقتك في إجراءات نقل الملكية",
  start_service_para_9: "📲 لا تشيل هم، التملك صار أسهل — تواصل معنا",
  donot_start_service: "شكرًا، غير مهتم الآن",
  including: "بما في ذلك",
  own_property: "بخاطرك تتملك هذا العقار ؟",
  payment_sccess_title: "شكرًا لك, تم السداد بنجاح",
  payment_sucess_hint:
    "سيتواصل معك الخبير التمويلي لتقديم الخدمة خلال ساعات العمل من الأحد إلى الخميس (عدا فترات الإجازات الرسمية) من الساعة التاسعة صباحًا حتى الخامسة مساءًا بحد أقصى خلال 48 ساعة من استلام الطلب",
  payment_sucess_hint_phone:
    "سيتواصل معك الخبير التمويلي على {{phone}} لتقديم الخدمة خلال ساعات العمل من الأحد إلى الخميس (عدا فترات الإجازات الرسمية) من الساعة التاسعة صباحًا حتى الخامسة مساءًا بحد أقصى خلال 48 ساعة من استلام الطلب",
  payment_hint_phone: "في حال تم الدفع .. سيتم التواصل بك على {{phone}}",
  success_title: "تم إرسال بياناتك بنجاح!",
  success_hint:
    "تم إرسال بياناتك إلى المعلن العقاري، وسيتواصل معك في أقرب فرصة",
  please_wait_while_redirecting: "برجاء الإنتظار حتى يتم إعادة توجيهك...",
  payment_fail_title: "تم فشل عملية الدفع",
  onlyEnglishNumbers:
    "يرجى إدخال الأرقام باستخدام الأرقام الإنجليزية فقط (0–9)",
  loading: " ...جاري التحميل",
  first_name: "الاسم الأول",
  email: "البريد الإلكتروني",
  submit: " إرسال",
  required: "الحقل مطلوب",
  invalid_phone: "رقم سعودي غير صالح (5xxxxxxxx)",
  villa: "فيلا",
  apartment: "شقة",
  land: "ارض",
  other: "اخرى",
  floor: "طابق",
  aqar_adress: "عنوان العقار",
  mortgage_consultation: "حسبة تمويلية",
  across_banks: "(على جميع البنوك)",
  find_aqar: "البحث عن عقار",
  "land for sale": "أرض للبيع",
  "villa for sale": "فيلا للبيع",
  "apartment for sale": "شقة للبيع",
  "building for sale": "مبنى للبيع",
  "home for sale": "منزل للبيع",
  "rest house for sale": "إستراحة للبيع",
  "farm for sale": "مزرعة للبيع",
  "shop for sale": "محلات للبيع",
  "floor for sale": "دور للبيع",
  send_info_confirmation:
    "هل أنت متأكد من رغبتك في مشاركة معلوماتك مع المعلن العقاري لإعلامه باهتمامك؟",
  confirm: "تأكيد",
  no: "لا",
  stc_number_connected: "رقم الجوال المسجل في STC Pay",
  loading_pay: "برجاء الإنتظار",
  STC: "STC Pay",
  otp_code: "رمز التحقق",
  confirm_info_send_btn: "تأكيد مشاركة معلوماتي مع المعلن العقاري",
  Financing_Consultation: "حسبة تمويلية (على جميع البنوك) + استشارة مفصلة",
  payment_header_hint: "يرجى الاختيار بالضغط على نوع الخدمة المطلوبة",
  select_consultation_first: "يرجى اختيار نوع الخدمة أولاً",
  third_consultation_title: "حسبة فك رهن و اعادة تمويل عقاري",
  payment_message: "في حال تم الدفع .. سيتم التواصل بك على",
  ai_consultation_title: "حسبة تمويل بضمان عقارك ",
  fourth_product_hint: "(متاحة فقط لمالكي العقارات – سيولة بضمان العقار)",
  first_product_hint: "(لمن يرغب بالحصول على تمويل عقاري جديد)",
  second_product_hint: "(لمن يرغب بتحليل موسع حسب حالته الشخصية)",
  third_product_hint: "(متاحة فقط لمن لديهم تمويل عقاري قائم)",
  important_notice: "تنبيه",
  i_understand: "تأكيد",
  dob_hijri_hint: "أدخل تاريخ الميلاد الخاص بالعميل بالتقويم الهجري",
  dob_greg_hint: "أدخل تاريخ الميلاد الخاص بالعميل بالتقويم الميلادي",
  B2C_dob_hijri_hint: "أدخل تاريخ الميلاد بالتقويم الهجري",
  B2C_dob_greg_hint: "أدخل تاريخ الميلاد بالتقويم الميلادي",
  hijri_date: "هجري",
  gregorian_date: "ميلادي",
  gregorian_date_example: "مثال: 14/05/2025",
  DOB: "تاريخ الميلاد للعميل",
  "date example": "مثال: 11/01/1410",
  Nationality: "الجنسية",
  Subsidized: "مدعوم",
  "First Home": "المسكن الاول",
  personal_data: "البيانات الشخصية",
  saudi: "سعودي",
  non_saudi: "غير سعودي",
  special_permit: "هل لديك إقامة مميزة ؟",
  aqar_type: "نوع العقار",
  apartment_type: "نوع الوحدة ؟",
  aqar_completed: "وحدة جاهزة",
  aqar_uncompleted: "تحت  الانشاء (عظم)",
  uncompleted_apartment: "غير مكتملة (عظم)",
  yes: "نعم",
  more_than_20: "أكبر من 20 سنة",
  less_than_20: "أصغر من 20 سنة",
  property_age_range: "عمر العقار",
  property_age: " عمر العقار (بالسنوات)",
  non_subsidized: "غير مدعوم",
  subsidized_status: "حالة الدعم",
  support_type: "نوع الدعم",
  yes_with_down_payment_package_support: "دعم باقة الدفع المقدم",
  yes_with_monthly_support: "الدعم الشهري",
  government: "حكومي مدني",
  military: "حكومي عسكري",
  private_sme: "قطاع خاص",
  private_enterprise: "قطاع خاص",
  retired: "متقاعد",
  net_salary: "الراتب الصافي",
  basic_salary: "الراتب الأساسي",
  military_rank: "الرتبة العسكرية",
  Pilote: "طيار",
  isEtzazSupported: "من منسوبي وزارة الدفاع؟",
  lender: "بنك نزول الراتب",
  net_salary_tooltip:
    "الراتب الصافي هو ما يتم إيداعه في حسابك البنكي نهاية الشهر",
  Rank: "رتبة",
  debt_data: "الإلتزامات الحالية (المديونيات)",
  debt_type: "نوع الإلتزام",
  amount: "القسط الشهري",
  total_amount: "إجمالي القسط الشهري",
  loan_duration: "الأشهر المتبقية",
  loan_total_amount: "إجمالي المبلغ المتبقي",
  debt_hint: "المستفيد ليس عليه أي ديون",
  add_debt: "إضافة دين جديد",
  loan_dbr_amount: "نسبة الإستقطاع للدين",
  obligations_hint: "بمجرد رفع تقرير سِمَة، سيتم قراءة الإلتزامات و عرضها",
  upload_simah: "رفع تقرير سِمَة",
  optional: "اختياري",
  or: "أو",
  cash_saving: "(التحويشه) المبلغ النقدي المتوفر من المدخرات",
  cash_saving_hint: "سيتم استخدام هذا المبلغ للدفعة المقدمة",
  add_savings: "إضافة مبلغ جديد",
  "Max Loan Amount": "الحد الاعلى لمبلغ التمويل العقاري",
  property_price_alone: "سعر العقار (بدون السعي)",
  save_calculation: "الإحتفاظ بالحسبة؟",
  customer_data: "أضف بيانات العميل",
  customer_name: "إسم العميل",
  save_calc_hint:
    "هل ترغب في حفظ هذه الحسبة؟ يمكنك الرجوع إليها من الشريط الجانبي > الحسبات المحفوظة.",
  user_phone: "جوال العميل (المهتم بإعلانك العقاري)",
  jobStartDateHijri: "تاريخ التعيين (الوظيفة الحالية)",
  date_example_1: "مثال: السنة/الشهر (02/1440)",
  start_service_date_tooltip: "يلزم تاريخ التعيين ﻹحتساب الراتب التقاعدي",
  salary_desc: "(الراتب في مستند تعريف الراتب)",
  Next: "التالي",
  Previous: "السابق",
  Submit: "تأكيد",
  skip_and_continue: "تخطي والمتابعة",
  please_set_calculator_info:
    "برجاء الانتظار سيتم تحويلك لادخال البيانات المطلوبة لعمل الحسبة اللازمة ",
  next_step: "الخطوة التالية",
  redirecting_in: "سيتم تحويلك بعد",
  seconds: "ثوانِ",
  continue_now: "المتابعة الآن",
  "date required": "التاريخ مطلوب",
  offplan: "على الخارطة",
  PersonalData: "البيانات الشخصية",
  WorkSector: "قطاع العمل",
  DebtData: "الإلتزامات الحالية",
  CashSaving: "التحويشه",

  personal_loan_helper_text:
    "أدخل عدد الأشهر المتبقية لسداد دينك الشخصي بالكامل",
  car_loan_helper_text:
    "أدخل عدد الأشهر المتبقية على سداد دين السيارة أو دفعات الإيجار التمويلي",
  mortgage_loan_helper_text:
    "أدخل عدد الأشهر المتبقية لسداد الرهن العقاري لمنزلك أو عقارك",
  additional_personal_loan_helper_text:
    "أدخل عدد الأشهر المتبقية لهذا التمويل الشخصي الإضافي أو التمويل الثانوي",
  total_loan_dbr_exceeded: "إجمالي نسبة الإستقطاع لا يجب أن يتجاوز {{max}} %",
};
